export const DisputeSource = {
    TICKET_MODAL: 'TICKET_MODAL',
    ACKNOW_MODAL: 'ACKNOW_MODAL',
}